import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select";
import { saveVendorFormUploads } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";


const VendorFormNext=()=>{
     const navigate= useNavigate();
        const [loaderspinner, setLoaderSpinner] = useState(false);
        const [filledForm,setFilledForm]= useState(null)
        const [isMsme, setIsMsme] = useState(false);
        const [isfssi, setIsFssi] = useState(false);
        const toastId = React.useRef(null);
        const [loader, setLoader] = useState(false);
        const [isActive, setIsActive] = useState(false);
        const [formSubmitted, setIsFormSubmiteed] = useState(false);
        const [declaration, setDeclartion]= useState(false)
        // const [gstnDoc, setGstnDoc]= useState(null);
        // const [panDoc, panDoc]= useState(null);
        // const [tdsDoc, tdsDoc]= useState(null);
        // const [latestCoDoc, setGstnDoc]= useState(null);
        // const [gstnDoc, setGstnDoc]= useState(null);
        // const [gstnDoc, setGstnDoc]= useState(null);

        const [formValues, setFormValues] = useState({
             
              gstn_document: { value: null,error: false }, 
              pan_document: { value: null,error: false },
              latest_co_status_document: { value: null,error: false },
              tds_document: { value: null,error: false },
              msme_document: {value: null, error: false},
              fssai_document: {value: null, error: false},
              cancel_cheque_document: {value: null, error: false},
              agreement_copy: {value: null, error: false},
              declaration: {value: 'I Agree', error: false}
            });

            const[formValues2,setFormValues2]= useState({})


            useEffect(() => {
              const isAuthenticate= localStorage.getItem("isAuthenticated");
      // if(!isAuthenticate){
      //   navigate("/vendor/validation");
      //   return;
      // }
                  let filledForm= localStorage.getItem("filledForm");
                  if(filledForm){

                    setFilledForm(filledForm)
                  }
                  let fssi=localStorage.getItem("fssi");
                  let msme=localStorage.getItem("msme");
                  setIsFssi(fssi==true || fssi=="true"? true:false)
                  setIsMsme(msme==true || msme=="true"? true:false)
                  console.log("printing form from previous page>>> ", JSON.parse(filledForm))
                  // console.log("the previous form>> ", JSON.parse(filledForm))
                  setFormValues2(JSON.parse(filledForm));
                },[]);


                const handleFormChange = (field, value) => {
                  let updatedValue = value;
                  console.log("here is a file>> ", value)
              
                  // Handle file inputs properly
                  if (field.endsWith("_document") && value instanceof File) {
                      updatedValue = value; // Store the file object directly
                  }
              
                  // Handle multi-select fields
                  if (field === "nature_of_business" || field === "business_category") {
                      updatedValue = value.map(option => option.value);
                  }
              
                  // Update state
                  setFormValues((prevState) => ({
                      ...prevState,
                      [field]: {
                          ...prevState[field], // Preserve existing properties (like `error`)
                          value: updatedValue, // Store the updated value
                      },
                      reference_id: {
                          ...prevState.reference_id,
                          value: formValues2.reference_id.value || localStorage.getItem("refId") || "", // Ensure refID is always set
                      }
                  }));
              };
              


                const handlePreviousPage=()=>{
                    navigate("/vendor/registration-form");
                    
                }

                const handleSubmitForm=async(e)=>{
                  e.preventDefault();
                  setIsActive(true)

                  let gstAvail= localStorage.getItem("gstAvailable");
                  let mcaAvail= localStorage.getItem("mcaAvailable");

                  if(gstAvail=="Yes"){
                    if(formValues.gstn_document.value==null || formValues.gstn_document.value==""){
                       if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please Fill GSTIN Document", {
          className: "small-toast"
        });
        setIsActive(false);
        return;
      }
                    }
                  }

                  if(mcaAvail=="Yes"){
                    if(formValues.latest_co_status_document.value==null || formValues.latest_co_status_document.value==""){
                       if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please Fill CIN Document", {
          className: "small-toast"
        });
        setIsActive(false);
        return;
      }
                    }
                  }

                         if(filledForm?.msme_registration_no?.value!="" && filledForm?.msme_registration_no?.value!=null){
                    if(formValues.msme_document.value==null || formValues.msme_document.value==""){
                       if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please Fill MSME Document", {
          className: "small-toast"
        });
        setIsActive(false);
        return;
      }
                    }
                  }

            if(filledForm?.fssai_regn_no?.value!="" && filledForm?.fssai_regn_no?.value!=null){
                    if(formValues.fssai_document.value==null || formValues.fssai_document.value==""){
                       if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please Fill FSSAI Document", {
          className: "small-toast"
        });
        setIsActive(false);
        return;
      }
                    }
                  }
                  
console.log("formValues>> ", formValues)
                  const requiredFields = [
                    "pan_document","cancel_cheque_document"
                  ];

                  let hasError = false;
    let updatedValues = { ...formValues };
  
    // if(isMsme || (updatedValues.msme_document==null || updatedValues.msme_document=="")){
    //   requiredFields.push("msme_document")
    // }
    // if(isfssi || (updatedValues.fssai_document==null || updatedValues.fssai_document=="")){
    //   requiredFields.push("fssai_document")
    // }
    requiredFields.forEach(key => {
      if (!updatedValues[key]?.value) {
        updatedValues[key] = { ...updatedValues[key], error: true };
        hasError = true;
      } else {
        updatedValues[key] = { ...updatedValues[key], error: false };
      }
    });

    setFormValues(updatedValues); 

    if (hasError) {
      console.log("cannot submit, fill mandatory")
     
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please Fill All The Required Fields", {
          className: "small-toast"
        });
      }

      setIsActive(false)
      
      return;
    }
                  console.log("final formValues>> ", formValues)
                  const formData= new FormData();

                  const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];

for (let key in formValues) {
  if(key=="declaration"|| key=="reference_id"){
    continue; // Skip declaration and reference_id
  }
  const file = formValues[key].value;
  if (file) {
    if (!allowedTypes.includes(file.type)) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(`File types must be PDF or Image (JPG/PNG).`, {
          className: "small-toast"
        });
      }
      // alert(`File type for ${key} must be PDF or Image (JPG/PNG).`);
      setIsActive(false);
      return;
    }
  }
}

                  Object.keys(formValues).forEach(key => {
                    if (formValues[key].value) {
                        formData.append(key, formValues[key].value); // Append file
                    }
                });

                  // Object.entries(formValues).forEach(([key, obj]) => {
                  //   if (Array.isArray(obj.value)) {
                  //     obj.value.forEach((val, index) => {
                  //       formData.append(`${key}[${index}]`, val);
                  //     });
                  //   } else {
                  //     formData.append(key, obj.value);
                  //   }
                  // });

                  formData.forEach((value, key) => {
                    console.log(`${key}: ${value}`);
                  });

                  

                  try{
                    const response= await saveVendorFormUploads(formData);
                    const res= response.data;
                    console.log("Here is upload response>> ", res);
                    if(res.status){
                      if(!toast.isActive(toastId.current)){
                        toastId.current= toast.success("Registration Successful",{
                                  className: "small-toast"
                                })
                      }
                      
                      setIsFormSubmiteed(true);
                    formData.forEach((value, key) => {
                      console.log(`${key}: ${value}`);
                    });
                    setTimeout(()=>{

                      navigate("/vendor/validation")
                  }, 2000)
                  localStorage.removeItem("filledForm2");
                    } else{
                      if(!toast.isActive(toastId.current)){
                        toastId.current= toast.warning(res.message,{
                                  className: "small-toast"
                                })
                      }
                      setIsActive(false)
                      console.log("why not register>> ", res)
                    }
                  }catch(err){
                    console.log("Error uploading files>> ", err)
                    if(!toast.isActive(toastId.current)){
                      toastId.current= toast.error(err.message,{
                                className: "small-toast"
                              })
                    }
                    setIsActive(false)
                  }
                   
                    
                            // localStorage.removeItem("filledForm2");
                            // localStorage.setItem("filledForm", JSON.stringify(formValues))

                    
                  }
  
                return(
                    <>
                    <ToastContainer/>
                    <SimpleBackdrop openLoader={isActive}/>
                    <Grid>
                    <SoftBox py={0} className="customerblock">
       <Grid container spacing={3}>
       <Grid item xs={12} lg={12} className="headerForm">
       
       <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
<img src={anmolLogo} alt="Logo" style={{ height: 100 }} />

<SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
 Vendor Registration
</SoftTypography>

{/* This empty box ensures the text remains centered */}
<div style={{ width: 50 }}></div>
</SoftBox>


       <Grid>
                     {loaderspinner ? <div style={{
                       position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                       zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                     }}>
                       <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                     </div> : ""}
       </Grid>
       
       </Grid>
       </Grid>
       </SoftBox>

        <SoftBox className="bp formBG">
            <form noValidate onSubmit={handleSubmitForm}>
            <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading textUppercase">Upload Documents</SoftTypography>
                   <SoftTypography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
  * Only PDF or images (JPG, JPEG, PNG) are allowed with max size upto 5MB.
</SoftTypography>

                   

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                     <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                               CIN (If MCA/ROC is Active) {(localStorage.getItem("mcaAvailable")=="Yes")? <span>*</span>: <></>}
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput  
                             type="file"
                            //  value={formValues.latest_co_status.value}
                             onChange={(e) => {
                              
                              const file = e.target.files[0];
                              if (file) {
                                const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                if (!allowedTypes.includes(file.type)) {
                                  if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                              className: "small-toast"
                                            })
                                  }
                                  return;
                                }
                                console.log("latest_co file is>>> ", file);
                                handleFormChange("latest_co_status_document", file);
                              }}}
                             placeholder="Street"
                             id="street"
                             size="medium" />
                         </SoftBox>
                       </Grid>
                     <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                  <SoftTypography
                                                    component="label"
                                                    variant="caption"
                                                    fontWeight="bold"
                                                    textTransform="capitalize"
                                                  >
                                                    TDS Exemption/Lower Deduction Certificate.
                                                  </SoftTypography>
                                                </SoftBox>
                                                <SoftInput
                                                  type="file"
                                                  id="tds_doc"
                                                  // disabled={formValues.tds_exemption?.value !== "Yes"}
                                                  error={formValues.tds_document.error}
                                                  // value={formValues.tds_document.value}
                                                  onChange={(e) => {
                                                    const file = e.target.files[0];
                              if (file) {
                                const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                if (!allowedTypes.includes(file.type)) {
                                  if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                              className: "small-toast"
                                            })
                                  }
                                  handleFormChange("tds_document", file);
                                  return;
                                }
                                console.log("tds_document file is>>> ", file);
                                handleFormChange("tds_document", file);
                                                    }}}
                                                />
                                              </SoftBox>
                                            </Grid>
                        <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3} id="mkcustomer">
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      GSTIN Document {(localStorage.getItem("gstAvailable")=="Yes")? <span>*</span>: <></>}
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    size="medium"
                                                    name="gstn_document"
                                                    id="gstn_document"
                                                    error={formValues.gstn_document.error}
                                                    // value={formValues.gstn_document.value}
                                                    onChange={(e) =>{
                                                      const file = e.target.files[0];
                                                      if (file) {
                                                        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                        if (!allowedTypes.includes(file.type)) {
                                                          if(!toast.isActive(toastId.current)){
                                                            toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                      className: "small-toast"
                                                                    })
                                                          }
                                                          handleFormChange("gstn_document", file);
                                                          return;
                                                        }
                                                        console.log("gstn file is>>> ", file);
                                                        handleFormChange("gstn_document", file);
                                                      }}}
                                                  />
                                              </SoftBox>
                                              </Grid>
                                              <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      PAN Document*
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    name="pan"
                                                    id="pan"
                                                    error={formValues.pan_document.error}
                                                    // value={formValues.pan_document.value}
                                                    onChange={(e) =>{
                                                      const file = e.target.files[0];
                                                      if (file) {
                                                        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                        if (!allowedTypes.includes(file.type)) {
                                                          if(!toast.isActive(toastId.current)){
                                                            toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                      className: "small-toast"
                                                                    })
                                                          }
                                                          handleFormChange("pan_document", file);
                                                          return;
                                                        }
                                                        console.log("pan file is>>> ", file);
                                                        handleFormChange("pan_document", file);
                                                      }
                                                    } }
                                                    
                                                    size="medium"
                                                    // inputProps={{ maxLength: "15" }}
                                                  />
                                                </SoftBox>
                                              </Grid>

                                              <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      Latest MSME Document {isMsme && <span>*</span>}
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    name="pan"
                                                    id="pan"
                                                    disabled={!isMsme}
                                                    // error={formValues.msme_document.error}
                                                    // value={formValues.pan_document.value}
                                                    onChange={(e) =>{
                                                      const file = e.target.files[0];
                                                      if (file) {
                                                        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                        if (!allowedTypes.includes(file.type)) {
                                                          if(!toast.isActive(toastId.current)){
                                                            toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                      className: "small-toast"
                                                                    })
                                                          }
                                                          handleFormChange("msme_document", file);
                                                          return;
                                                        }
                                                        console.log("msme file is>>> ", file);
                                                        handleFormChange("msme_document", file);
                                                      }
                                                    } }
                                                    
                                                    size="medium"
                                                    // inputProps={{ maxLength: "15" }}
                                                  />
                                                </SoftBox>
                                              </Grid>

                                              <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      FSSAI Document {isfssi && <span>*</span>}
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    name="pan"
                                                    id="pan"
                                                    disabled={!isfssi}
                                                    // error={formValues.fssai_document.error}
                                                    // value={formValues.pan_document.value}
                                                    onChange={(e) =>{
                                                      const file = e.target.files[0];
                                                      if (file) {
                                                        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                        if (!allowedTypes.includes(file.type)) {
                                                          if(!toast.isActive(toastId.current)){
                                                            toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                      className: "small-toast"
                                                                    })
                                                          }
                                                          handleFormChange("fssai_document", file);
                                                          return;
                                                        }
                                                        console.log("fssai file is>>> ", file);
                                                        handleFormChange("fssai_document", file);
                                                      }
                                                    } }
                                                    
                                                    size="medium"
                                                    // inputProps={{ maxLength: "15" }}
                                                  />
                                                </SoftBox>
                                              </Grid>

                                              <Grid item xs={12} sm={4}>
                                              <SoftBox mb={3}>
                                                  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography
                                                      component="label"
                                                      variant="caption"
                                                      fontWeight="bold"
                                                      textTransform="capitalize"
                                                    >
                                                      Cancel Cheque Document*
                                                    </SoftTypography>
                                                  </SoftBox>
                                                  <SoftInput
                                                    type="file"
                                                    name="pan"
                                                    id="pan"
                                                    error={formValues.cancel_cheque_document.error}
                                                    // value={formValues.pan_document.value}
                                                    onChange={(e) =>{
                                                      const file = e.target.files[0];
                                                      if (file) {
                                                        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                        if (!allowedTypes.includes(file.type)) {
                                                          if(!toast.isActive(toastId.current)){
                                                            toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                      className: "small-toast"
                                                                    })
                                                          }
                                                          handleFormChange("cancel_cheque_document", file);
                                                          return;
                                                        }
                                                        console.log("pan file is>>> ", file);
                                                        handleFormChange("cancel_cheque_document", file);
                                                      }
                                                    } }
                                                    
                                                    size="medium"
                                                    // inputProps={{ maxLength: "15" }}
                                                  />
                                                </SoftBox>
                                              </Grid>

                     <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                         <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                           <SoftTypography
                             component="label"
                             htmlFor="agreement_copy"
                             variant="caption"
                             fontWeight="bold"
                           >
                             Agreement Copy
                           </SoftTypography>
                         </SoftBox>
                         <SoftInput
                           type="file"
                           name="agreement_copy"
                           id="agreement_copy"
                           inputProps={{ accept: ".pdf,.jpg,.jpeg,.png" }}
                           error={formValues.agreement_copy.error}
                           onChange={(e) => {
                             const file = e.target.files[0] || null;
                             if (file && !["application/pdf", "image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
                               if (!toast.isActive(toastId.current)) {
                                 toastId.current = toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed", {
                                   className: "small-toast"
                                 });
                               }
                               e.target.value = "";
                               handleFormChange("agreement_copy", null);
                               return;
                             }
                             handleFormChange("agreement_copy", file);
                           }}
                           size="medium"
                         />
                       </SoftBox>
                     </Grid>

                     </Grid>
                   </SoftBox>
                     <SoftBox py={3} className="customerblock">

                     <Grid container spacing={3}>
                     <Card sx={{ overflow: "visible" }}>
                        <SoftBox p={3}>
                            <div style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
<input 
// style={{marginTop:'10px'}}
 type="checkbox" 
 style={{ cursor: "pointer", marginTop:'10px' }} 
 checked={declaration} 
 onChange={(e) => setDeclartion(e.target.checked)} 
/>
<SoftTypography variant="h5" id="form_heading">
 <span style={{ fontSize: "12px" }}>
   I/W<span style={{textTransform: 'lowercase'}}>e</span> <span style={{textTransform: 'lowercase'}}> declare that the above information given here in including the attachments are correct to the best of my knowledge. </span>
 </span>
</SoftTypography>
</div>
<Grid container display="flex" justifyContent="space-between" mt={2} >
<Grid item>
           <SoftButton onClick={handlePreviousPage} variant="contained" color="success">
             Previous
           </SoftButton>
         </Grid>
         <Grid item>
           <SoftButton disabled={!declaration} type="submit" variant="contained" color="primary">
             Save & Submit
           </SoftButton>
         </Grid>
       </Grid>
                        </SoftBox>
                     </Card>
                     </Grid>
                     </SoftBox>


                 
                   

                   

                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>
            </form>
        </SoftBox>
                    </Grid>
                    </>
                )
}

export default VendorFormNext;